import { fetchRatePlanRoomType } from './api';

export const roomExtraReducers = (builder) => {
  builder
    .addCase(fetchRatePlanRoomType.pending, (state, action) => {
      // track the latest in-flight request so a slower, older response
      // (e.g. cancellation didn't land in time) can be ignored below
      state.currentRequestId = action.meta.requestId;
      state.loading = true;
      state.optionLoader = true;
      state.status = {
        apiMessage: '',
        apiSuccess: true,
      };
    })
    .addCase(fetchRatePlanRoomType.fulfilled, (state, action) => {
      if (action.meta.requestId !== state.currentRequestId) {
        // a newer request has since been dispatched; this response is stale
        return;
      }
      const { payload } = action;
      if (!payload.status.apiSuccess) {
        state.corpCode = '';
      }
      const isActiveRoom = state.roomCounts?.findIndex((room) => room?.isActive);
      state.selectedRooms = state.selectedRooms?.map((room, index) => {
        console.log('room:', room);

        if (isActiveRoom === index) {
          return room; // keep active room as-is
        }

        const roomId = room._id;

        // payload.roomType can be absent on a degraded response (see the
        // guard on state.roomType below) — fall through to keeping the
        // existing room rather than throwing on .find() of undefined
        const newData = payload.roomType?.find(r => {
          console.log('r1:', r);
          return r._id === roomId;
        });
        console.log('newData:', { ...newData });

        return newData ? { ...newData } : {...room};
      });

      if (isActiveRoom !== -1) {
        console.log("payload.selectedRoom", payload.selectedRoom);
        if (payload.selectedRoom.length > 0) {
          state.selectedRooms[isActiveRoom] = {
            ...state.selectedRooms[isActiveRoom],
            ...payload.selectedRoom[0],
          };
        }
      }
      state.cancellationPolicy = payload.cancellationPolicy;
      state.isRoomAvailable = payload.isRoomAvailable;
      state.selectedRoom = payload.selectedRoom;
      // always take the freshly fetched packages, and keep the per-room
      // cache in sync with them — previously, once a room slot had been
      // switched to at least once, this cache was never refreshed again,
      // so later fetches for that room silently kept showing whatever
      // (possibly incomplete) packages were cached the first time
      state.allOptions = payload.allOptions;
      state.allOptions2[isActiveRoom] = payload.allOptions;
      state.initialOptions = payload.allOptions;
      state.firstAllOptions = payload.allOptions;
      state.isCorpCode = payload.isCorpCode;
      state.ratePlans = payload.ratePlans;
      // api.js now guarantees roomType is a real array (retrying, then
      // rejecting rather than fulfilling, if the backend omits it) — so a
      // plain assignment here is correct, including a legitimate empty
      // array meaning "no rooms available for these dates".
      state.roomType = payload.roomType;
      state.timeSpan = payload.timeSpan;
      state.status = payload.status;
      state.ratePlanCategory = '';
      state.optionLoader = false;
      state.packageDisabledIds = [];

      if (Object.keys(payload.groupCodeDetails).length > 0) {
        state.groupCode = payload.groupCodeDetails.groupCode;
        state.groupCodeDetails = payload.groupCodeDetails;
      }

      state.loading = false;
      // reset the switch flag after handling
      state.isActiveRoomSwitch = false;
    })
    .addCase(fetchRatePlanRoomType.rejected, (state, action) => {
      if (action.meta.requestId !== state.currentRequestId) {
        // a newer request has since been dispatched; ignore this stale rejection
        return;
      }
      const { payload } = action;
      state.loading = payload.loading || false;
      state.optionLoader = payload.optionLoader || false;
      state.status = payload?.status || { apiMessage: '', apiSuccess: true };
      state.isRoomAvailable = payload.isRoomAvailable;
    });
};
